// @flow

import type {Language, ModalProps} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {mergeAll} from 'ramda'
import {appSelectors, portfoliosActions, uiActions} from '@/store'

type Props = {
  setupPortfolioListForm: () => void,
  moveCompanies: () => void,
  showEditModal: (props: ModalProps) => void,
  l: Language,
  disabled: boolean,
}

const RawMoveButton = (props: Props) =>
  <button id='move_button'
    className="btn btn-success"
    disabled={props.disabled}
    onClick={() => {
      props.setupPortfolioListForm()
      props.showEditModal({
        title: 'Move companies to',
        onConfirm: props.moveCompanies,
      })
    }}
  >
    {props.l('Move')}
  </button>

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
  mergeAll([portfoliosActions, uiActions]),
)(RawMoveButton)



// WEBPACK FOOTER //
// ./src/views/portfolios-page/move-button.js